<ion-grid *ngIf="employees$ | async as employees">
	<ng-container *ngIf="employees.isSkeleton">
		<ion-grid class="side-menu-wrapper text-center">
			<ion-spinner class="ion-spinner"></ion-spinner>
		</ion-grid>
	</ng-container>
	<ng-container *ngIf="!employees.isSkeleton">
		<ion-row>
			<ion-col>
				<ion-grid>
					<ion-row>
						<ion-col col="12">
							<dx-data-grid
								id="gridContainer"
								[dataSource]="employees.data"
								[allowColumnResizing]="true"
								[columnAutoWidth]="true"
								[showBorders]="true"
							>
								<dxo-search-panel
									[visible]="true"
									[width]="240"
									placeholder="Search..."
								></dxo-search-panel>
								<dxo-header-filter [visible]="true"></dxo-header-filter>
								<dxo-column-chooser
									[enabled]="true"
									mode="select"
								></dxo-column-chooser>
								<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

								<dxi-column
									caption="Actions"
									dataField="id"
									[allowFiltering]="false"
									[allowSorting]="false"
									cellTemplate="cellTemplate"
									[width]="150"
								>
								</dxi-column>

								<dxi-column dataField="title" caption="Title"></dxi-column>
								<dxi-column
									cellTemplate="cellTemplateImage"
									caption="Logo"
								></dxi-column>

								<dxi-column
									dataField="startTime"
									caption="Start Date"
									dataType="datetime"
									format="dd/MM/yyyy hh:mm aa"
									[width]="150"
								></dxi-column>
								<dxi-column
									dataField="endTime"
									caption="End Date"
									dataType="datetime"
									format="dd/MM/yyyy hh:mm aa"
									[width]="150"
								></dxi-column>

								<div *dxTemplate="let d of 'cellTemplate'">
									<a (click)="editScheduleEvent(d.data)" class="cursor">Edit</a>
									/
									<a
										appConfirmBox
										(learnDelete)="deleteScheduleEvent(d.data.id)"
										title="Delete Event"
										subTitle="Are you sure you want to delete your Event ?"
										class="Body_S text-right"
										>Delete</a
									>
								</div>

								<div
									*dxTemplate="let d of 'cellTemplateImage'"
									class="text-center"
								>
									<img [src]="d.data.imageUrl" class="logoUrl" />
								</div>

								<dxo-toolbar>
									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<ion-button (click)="addScheduleEvent()"
												><ion-icon name="add-outline"></ion-icon
											></ion-button>
										</div>
									</dxi-item>

									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<p class="Heading_M">Add Networking Slot</p>
										</div>
									</dxi-item>

									<dxi-item name="columnChooserButton"></dxi-item>

									<dxi-item name="searchPanel"></dxi-item>
								</dxo-toolbar>
							</dx-data-grid>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-col>
		</ion-row>
	</ng-container>
</ion-grid>
